module.exports = "/assets/data/5a739636a2b4b58936a9e3f84baac8de-HU17.data.json";